import {
  EffectConfig,
  OneOfEntranceOngoingEffects,
  OneOfScrollEffects,
  ScrollEffectConfig,
  ScrollEffectParams,
} from '@wix/effects-kit';
import type { Effect } from '../types';

export const cleanupPanelEffect = (
  panelEffect: Effect,
  effectConfig:
    | EffectConfig<OneOfEntranceOngoingEffects>
    | ScrollEffectConfig<OneOfScrollEffects>
    | null,
): Effect => {
  if (!effectConfig) {
    return { name: panelEffect.name };
  }
  const rangeValue = (panelEffect.params as ScrollEffectParams)?.range;
  const { schema, range } =
    effectConfig as ScrollEffectConfig<OneOfScrollEffects>;
  const effectSchema = rangeValue ? { ...schema[rangeValue], range } : schema;

  const params = Object.fromEntries(
    Object.entries(panelEffect.params || {}).filter(
      ([key]) => key in effectSchema!,
    ),
  ) as Effect['params'];

  return { name: panelEffect.name, params };
};
